import script from "./UserMixin.vue?vue&type=script&lang=ts"
export * from "./UserMixin.vue?vue&type=script&lang=ts"

export default script